import { HttpClient, HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { RequestsProvider } from '../../providers/requests/requests';

@IonicPage()
@Component({
  selector: 'page-add-rate-manual-popup',
  templateUrl: 'add-rate-manual-popup.html',
})
export class AddRateManualPopupPage {

  rateTypeDDL: any = 3;
  rateNameInput : any = '';
  timesheetId : any = 0;
  addRateInstructions : string = "";

  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public viewCtrl: ViewController
    , public http: HttpClient
    , public global: GlobalProvider
    , public requests:RequestsProvider

  ) {

    // Get parameters passed to the modal
    if (this.navParams.get('timesheetid')) {
      this.timesheetId = this.navParams.get('timesheetid');
    }
    this.getAddRateInstructions();

  }

  getAddRateInstructions() {

    var p: any = {};
    // p.agencyid = this.global.agencyid;

    const params = new HttpParams().set('j', JSON.stringify(p));

    this.http.post('timesheets/GetAddRateMicrositeContent/', params).subscribe(

      (data : any) => {
        
        if(data.length){
          this.addRateInstructions = data[0]["content1"];  
        }
        //this.addRateInstructions = data;
      
      },
      error => {
        alert('error');
      }
    );
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad AddRateManualPopupPage');
  }

  saveRate () {
   console.log(this.rateTypeDDL, this.rateNameInput); 

   let p = {
    ratename: this.rateNameInput,
    rateperid: this.rateTypeDDL,
    timesheetid: this.timesheetId,
    contacttype: this.global.contacttype
   };

  const params = new HttpParams().set('j',JSON.stringify(p));

  this.http.post('timesheets/save_rate_manual/',params).subscribe(
      (data: any) => {
        
  
        if(data[0].success) {

          this.global.presentToast("Success");

          //close pop 
          this.viewCtrl.dismiss({ratesid: data[0].ratesid, ratename: this.rateNameInput, ratesperid: this.rateTypeDDL});

        
          //this.requests.httpRequestGrid1_read("");
          // RefreshGrids();

        } else {
            let message = data[0].message || "Something went wrong , could not add rate."
            this.global.presentToast(message, 20000);
        }
      
        
  

      }
    )
   
   
  }

  closePopup() {
    this.viewCtrl.dismiss();
  }


}



// WEBPACK FOOTER //
// ./src/pages/add-rate-manual-popup/add-rate-manual-popup.ts